var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "items" }, [
    _c("h1", [_vm._v("Items")]),
    _vm._v(" "),
    _vm.items.length > 0
      ? _c("div", { staticClass: "table-wrap" }, [
          _c(
            "div",
            [
              _c("router-link", { attrs: { to: { name: "NewItem" } } }, [
                _vm._v("Add Item")
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "table",
            [
              _vm._m(0),
              _vm._v(" "),
              _vm._l(_vm.items, function(item, index) {
                return _c("tr", { key: index }, [
                  _c("td", [_vm._v(_vm._s(item.name))]),
                  _vm._v(" "),
                  _c(
                    "td",
                    { attrs: { align: "center" } },
                    [
                      _c(
                        "router-link",
                        {
                          attrs: {
                            to: { name: "EditItem", params: { id: item._id } }
                          }
                        },
                        [_vm._v("Edit")]
                      ),
                      _vm._v(" |\n          "),
                      _c(
                        "a",
                        {
                          attrs: { href: "#" },
                          on: {
                            click: function($event) {
                              return _vm.deleteItem(item._id)
                            }
                          }
                        },
                        [_vm._v("Delete")]
                      )
                    ],
                    1
                  )
                ])
              })
            ],
            2
          )
        ])
      : _c(
          "div",
          [
            _vm._v("\n    There are no items.. Lets add one now "),
            _c("br"),
            _c("br"),
            _vm._v(" "),
            _c(
              "router-link",
              {
                staticClass: "add_item_link",
                attrs: { to: { name: "NewItem" } }
              },
              [_vm._v("Add Item")]
            )
          ],
          1
        )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("td", [_vm._v("Item Name")]),
      _vm._v(" "),
      _c("td", { attrs: { align: "center" } }, [_vm._v("Action")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7695aa31", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7695aa31","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/items/Items.vue
// module id = null
// module chunks = 